import React from 'react'

const phaseListContext = React.createContext({
  getWorkflow: () => {},
})

export default phaseListContext
